import LiveJobs from "../components/Sections/LiveJobs";

export default function LiveJobsPage() {
  return (
      <>
          <LiveJobs />
  
      </>
  ) 
}